import { render } from "./VosRecord.vue?vue&type=template&id=2dcdc353&scoped=true"
import script from "./VosRecord.vue?vue&type=script&lang=js"
export * from "./VosRecord.vue?vue&type=script&lang=js"

import "./VosRecord.vue?vue&type=style&index=0&id=2dcdc353&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcdc353"]])

export default __exports__